module.exports = __webpack_public_path__ + "public/img/jmcm.1447f31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/jmcm.png
// module id = qXMr
// module chunks = 1